export default __webpack_public_path__ + "static/headerLogo60-e86ce59e23b7c59cc16cd6bbe468a635.png";